<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-0" v-text="'Usuwanie umowy'" />
        </template>

        <page-preloader v-if="isLoading" min-height="10rem" />

        <div v-else class="text-center">
            <a-icon
                icon="WarningFull"
                width="2.5rem"
                height="2.5rem"
                class="text-warning my-3"
            />

            <h5 class="font-weight-normal mt-3 mb-0">
                Czy na pewno chcesz usunąć umowę z Operatorem {{ operatorName }}?
                Skutkuje to ograniczonym zakresem działania niektórych funkcjonalności systemu kaucyjnego
                (dotyczy m.in. raportowania, zarządzania workami czy obiegu kuponów).
                <br />
                Usunięcie umowy
                <strong v-text="'nie jest jednoznaczne'" />
                z jej rozwiązaniem.
            </h5>

            <h5
                v-text="'Operacji nie można odwrócić.'"
                class="font-weight-normal text-orange mb-3"
            />

            <h5
                v-if="hasUnmappedKplLocations"
                v-text="'UWAGA! Umowę usuniesz również na portalu Kaucyjni.pl'"
                class="font-weight-normal text-orange mb-3"
            />

            <ui-checkbox-input
                v-if="hasUnmappedKplLocations"
                v-model="isConfirmed"
                class="text-primary text-sm"
                name="delete-contract-confirm"
                :label="`
                    Potwierdzam, że zapoznałem/am się z powyższą informacją i mam świadomość,
                    że umowa zostanie usunięta zarówno w EuroPlatform jak i Kaucyjni.pl
                    <span class='text-danger'>*</span>
                `"
            />
        </div>

        <template #footer>
            <the-btn
                text="Nie, zamknij"
                class="btn-outline-custom"
                :disabled="isLoading"
                @click="closeModal"
            />
            <the-btn
                text="Tak, usuń"
                class="btn-danger"
                :disabled="isDeleteButtonDisabled"
                @click="confirmDeleteContract"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data: () => ({
        isLoading: false,
        hasUnmappedKplLocations: false,
        isConfirmed: false
    }),

    async created() {
        await this.fetchUnmappedKplLocations()
    },

    computed: {
        ...mapGetters('drs', ['nip']),
        ...mapGetters('drsOperators', ['operatorContract', 'getOperatorById']),

        isDeleteButtonDisabled() {
            return this.isLoading || (this.hasUnmappedKplLocations && !this.isConfirmed)
        },

        operatorName() {
            const operatorServiceId = this.operatorContract?.operatorServiceId
            return this.getOperatorById(operatorServiceId)?.name || ''
        }
    },

    methods: {
        ...mapActions('drsOperators', ['deleteContract', 'loadAndMapContract']),

        async fetchUnmappedKplLocations() {
            try {
                this.isLoading = true
                const { status, data } = await this.$store.$api.get(
                    `users/${this.$store.getters.getUser.id}/drs/companies?nips=${this.nip}`
                )

                if (status !== 200) {
                    throw new Error('Failed fetchUnmappedKplLocations')
                }

                const locationsKpl = data.data?.companies[0]?.locations || []
                const unmappedLocationsKpl = locationsKpl.filter(loc => !loc.mapped_data || loc.mapped_data.state !== 'ACTIVE')

                this.hasUnmappedKplLocations = !!unmappedLocationsKpl.length
            } catch (error) {
                console.error(error)
                this.hasUnmappedKplLocations = false
            } finally {
                this.isLoading = false
            }
        },

        async confirmDeleteContract() {
            try {
                this.isLoading = true
                await this.deleteContract(this.operatorContract.id)

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Umowa została usunięta'
                })
            } catch (error) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd podczas usuwania umowy'
                })
                console.error(error)
            } finally {
                await this.loadAndMapContract(this.operatorContract.operatorServiceId)
                this.closeModal()
                this.isLoading = false
            }
        },

        closeModal() {
            this.$store.dispatch('toggleModal', false)
        }
    }
}
</script>
